import { ContentBlock, GuideTypes, ImageCarousel, Metadata } from "../models";
import { Entry } from "contentful";
import { findContent, parseIntoImage } from "../utils";
import { FieldMapping } from "../types";

export const createImageCarousel = (
  fieldMapping: FieldMapping<ImageCarousel>,
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
): ImageCarousel => {
  const images = fieldMapping.images.map(id =>
    findContent(entries, id, guideType),
  );

  return {
    images: images?.map(image =>
      parseIntoImage(image?.fields.richContent.content[0].data),
    )
  };
};
